import React from 'react';
import { useFormikContext } from 'formik';
import { StyledButton, StyledButtonProps } from 'src/kit';

export type FormikSubmitButtonProps = StyledButtonProps & {
  children?: React.ReactNode;
};

export const FormikSubmitButton = ({ children, ...props }: FormikSubmitButtonProps) => {
  const { isSubmitting } = useFormikContext();
  const defaultText = isSubmitting ? 'Saving...' : 'Save';

  return (
    <StyledButton type="submit" disabled={isSubmitting} {...props}>
      {children || defaultText}
    </StyledButton>
  );
};

FormikSubmitButton.defaultProps = {
  variant: 'caInverted',
  size: 'sm'
};
